import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';

// view

//

import {
  ProjectList,
  NewProject,
  ProjectDetail,
  EditProject,
  ProjectDashboard,
  ProjectActivityLog,
} from 'views/Project';
import Loading from 'components/Loading';
import { HomeNavbar } from '../components/Nevbars';
import { MainFooter } from '../components/Footers';
import { MainSidebar } from '../components/Sidebar';
import { NotFound, AccessDenied } from '../components/Error';
import { hasModuleAccess } from '../utils/functions/accessRight';
import * as actions from '../redux/actions';

export function Project() {
  const module = 'PROJECT';
  const prefix = '/project';
  const name = 'PROJECT';
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const me = useSelector((state) => state.me);

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const handleOnMobileNavOpen = () => {
    setMobileNavOpen(true);
  };
  const handleOnMobileNavClose = () => {
    setMobileNavOpen(false);
  };
  useEffect(() => {
    dispatch(actions.meGet());
    return () => {};
  }, []);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, []);
  if (!me.userData) {
    return <Loading />;
  }
  if (!hasModuleAccess(me, module)) {
    return <AccessDenied moduleLabel="โครงการ" />;
  }
  return (
    <div className="h-screen overflow-hidden">
      <MainSidebar
        onMobileClose={handleOnMobileNavClose}
        openMobile={isMobileNavOpen}
        me={me}
      />
      <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />

      <div className={`relative ${'lg:ml-20'} transition-all duration-200 px-8 overflow-hidden`} style={{ paddingTop: '33px' }}>
        <div className="py-4">
          <Switch>
            <Route exact path={`${prefix}/dashboard`}>
              <ProjectDashboard title="แดชบอร์ด" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/project`}>
              <ProjectList title="โครงการ" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/project/new`}>
              <NewProject title="เพิ่มโครงการ" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/project/detail/:id`}>
              <ProjectDetail title="รายละเอียด" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/project/edit/:id`}>
              <EditProject title="แก้ไข" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/activity-log`}>
              <ProjectActivityLog title="บันทึกกิจกรรม (โครงการ)" />
            </Route>
            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </div>
      </div>

    </div>
  );
}

export default Project;
